export default "__VITE_ASSET__CNKHJ2bJ__"